var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn-toggle',{staticClass:"button-group",attrs:{"active-class":"is-active","tile":"","group":"","mandatory":"","dense":_vm.isSmall,"value":_vm.selectedIndex},on:{"change":_vm.onChange}},_vm._l((_vm.items),function(item,i){return _c('v-btn',{key:i},[_vm._v(" "+_vm._s(item)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }